import * as React from 'react';
import { styled, alpha } from '@mui/material/styles';
import Button, { ButtonProps } from '@mui/material/Button';
import Menu, { MenuProps } from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

const StyledMenu = styled((props: MenuProps) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'right',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'right',
    }}
    sx={{ borderRadius: '2px' }}
    {...props}
  />
))(({ theme }) => ({
  '& .MuiPaper-root': {
    borderRadius: 2,
    marginTop: theme.spacing(1),
    minWidth: 180,
    color:
      theme.palette.mode === 'light'
        ? 'rgb(55, 65, 81)'
        : theme.palette.grey[300],
    boxShadow:
      'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
    '& .MuiMenu-list': {
      padding: '4px 0',
    },
    '& .MuiMenuItem-root': {
      '& .MuiSvgIcon-root': {
        fontSize: 18,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5),
      },
      '&:active': {
        backgroundColor: alpha(
          theme.palette.primary.main,
          theme.palette.action.selectedOpacity
        ),
      },
    },
  },
}));

export type ButtonMenuProps = Omit<ButtonProps, 'onClick'> & {
  menuItems: string[];
  disabled?: boolean;
  label: string;
  onClick: Function;
  color?: string; //"inherit" | "primary" | "secondary" | "success" | "error" | "info" | "warning" | undefined
};

export const ButtonMenu = ({
  menuItems,
  disabled = false,
  label,
  onClick,
  color,
  sx: buttonSx = {},
}: ButtonMenuProps) => {
  const buttonRef = React.useRef<any>(null);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const menuWidth = anchorEl && anchorEl.offsetWidth ? anchorEl.offsetWidth : 0;

  return (
    <div>
      <Button
        ref={buttonRef}
        disabled={disabled}
        variant="outlined"
        onClick={handleClick}
        endIcon={<KeyboardArrowDownIcon />}
        sx={buttonSx}
      >
        {label}
      </Button>
      <StyledMenu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        PaperProps={{
          sx: menuWidth ? { width: { xs: menuWidth, sm: 'auto' } } : {},
        }}
      >
        {menuItems &&
          menuItems
            ?.filter(mi => mi != label)
            ?.map((menuItem, index) => (
              <MenuItem
                key={index}
                onClick={() => {
                  onClick(menuItem);
                  handleClose();
                }}
                disableRipple
              >
                {menuItem}
              </MenuItem>
            ))}
      </StyledMenu>
    </div>
  );
};
